import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Flex } from 'hljd'
import RookieTask from './RookieTask'
import Store from './store'
import ShopExposure from './ShopExposure'
import { Provider } from 'mobx-react'
import Modals from './Modals'
import SameShopPreview from './SameShopPreview'
import { HLJ_STATISTIC, getMerchantInfo } from '@util'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getTaskPageData()
    HLJ_STATISTIC({
      page_name: '新手任务页',
      event_type: 'element_view',
      element_tag: 'new_task_view',
      data_id: getMerchantInfo().id,
      data_type: 'Merchant'
    })
  }

  render() {
    return (
      <HeaderView
        contentStyle={{
          backgroundColor: 'initial',
          height: '100%',
          paddingBottom: 0
        }}
      >
        <Provider store={this.store}>
          <>
            <Flex d="v" style={{ height: '100%' }}>
              <Flex>
                <SameShopPreview />
                <ShopExposure />
              </Flex>

              <RookieTask />
            </Flex>
            <Modals />
          </>
        </Provider>
      </HeaderView>
    )
  }
}
